<div class="card p-3 mb-3" *ngIf="ranking"
  [ngClass]="(type === 'measure' && done) ? 'valid' : (type === 'measure' && !done) ? 'invalid' : ''">
  <div class="container py-3">

    <!-- only choice THSarabun use own scss -->

    <h4 class="mt-3 mb-5 text-left">
      <span *ngIf="isAutoNumber"
        [ngClass]="font === 'arial' ? 'Arial' : font === 'times-new-roman' ? 'TimeNewRoman' : font === 'calibri' ? 'Calibri' : font === 'comic-sans-ms' ? 'ComicSansMS' : font === 'th-sarabun' ? 'THsarabun-Header' : font === 'K2D' ? 'K2D' : ''">{{ ranking.NUMBER }}.
        {{ ranking.VALUE[0].question }}</span>
      <span *ngIf="!isAutoNumber"
        [ngClass]="font === 'arial' ? 'Arial' : font === 'times-new-roman' ? 'TimeNewRoman' : font === 'calibri' ? 'Calibri' : font === 'comic-sans-ms' ? 'ComicSansMS' : font === 'th-sarabun' ? 'THsarabun-Header' : font === 'K2D' ? 'K2D' : ''">{{ questionNumber }}.
        {{ ranking.VALUE[0].question }}</span>
    </h4>
    <div class="my-5 container">

      <div class="row">
        <div class="col-lg-6 col-md-12 col-sm-12">
          <h2 class="mt-3" style="margin-bottom: 36px;"
            [ngClass]="font === 'arial' ? 'Arial' : font === 'times-new-roman' ? 'TimeNewRoman' : font === 'calibri' ? 'Calibri' : font === 'comic-sans-ms' ? 'ComicSansMS' : font === 'th-sarabun' ? 'THSarabun' : font === 'K2D' ? 'K2D' : ''">
            ตัวเลือก
          </h2>
          <div cdkDropList #activeList="cdkDropList" class="example-list px-3" cdkDropListOrientation="vertical"
            [cdkDropListData]="choices" [cdkDropListConnectedTo]="[inactiveList]" (cdkDropListDropped)="drop($event)">
            <div class="card p-3 my-3 choice" style="cursor: move;" *ngFor="let item of choices" cdkDrag>
              <span
                [ngClass]="font === 'arial' ? 'Arial' : font === 'times-new-roman' ? 'TimeNewRoman' : font === 'calibri' ? 'Calibri' : font === 'comic-sans-ms' ? 'ComicSansMS' : font === 'th-sarabun' ? 'THsarabun-choice' : font === 'K2D' ? 'K2D' : ''">
                {{ item.choice_detail }}
              </span>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-md-12 col-sm-12">
          <h2 class="my-3"
            [ngClass]="font === 'arial' ? 'Arial' : font === 'times-new-roman' ? 'TimeNewRoman' : font === 'calibri' ? 'Calibri' : font === 'comic-sans-ms' ? 'ComicSansMS' : font === 'th-sarabun' ? 'THSarabun' : font === 'K2D' ? 'K2D' : ''">
            คำตอบ
          </h2>
          <span style="font-size: medium;" class="lifedi-color"
            [ngClass]="font === 'arial' ? 'Arial' : font === 'times-new-roman' ? 'TimeNewRoman' : font === 'calibri' ? 'Calibri' : font === 'comic-sans-ms' ? 'ComicSansMS' : font === 'th-sarabun' ? 'THSarabun' : font === 'K2D' ? 'K2D' : ''">(ลากใส่ตรงนี้)</span>

          <div cdkDropList #inactiveList="cdkDropList" class="example-list px-3" style="height:fit-content"
            cdkDropListOrientation="vertical" [cdkDropListData]="answer" [cdkDropListConnectedTo]="[activeList]"
            (cdkDropListDropped)="drop($event)">
            <div class="card p-3 my-3 answer" *ngFor="let item of answer" cdkDrag>
              <span
                [ngClass]="font === 'arial' ? 'Arial' : font === 'times-new-roman' ? 'TimeNewRoman' : font === 'calibri' ? 'Calibri' : font === 'comic-sans-ms' ? 'ComicSansMS' : font === 'th-sarabun' ? 'THsarabun-choice' : font === 'K2D' ? 'K2D' : ''">{{ item.choice_detail }}</span>
            </div>
          </div>
        </div>
      </div>


    </div>
  </div>
</div>
